export const CREATE_ACTIVITY_PATH = 'api/landlord/activities';
